import { atom } from 'recoil';

export const setDoctorMedicine = atom({
    key: 'setDoctorMedicine', // unique ID (with respect to other atoms/selectors)
    default: [] // default value (aka initial value)
});  